export default "__VITE_ASSET__URJzB4BP__"